<template>
    <div class="table-responsive">
        <loader v-if="isLoading" />
        <b-table-simple v-else borderless hover class="list">
            <b-thead>
                <b-tr>
                    <b-th v-if="wpDiscounts.length > 0"></b-th>
                    <b-th>Category:</b-th>
                    <b-th>Amount (%):</b-th>
                    <b-th>Added:</b-th>
                    <b-th>Added By:</b-th>
                    <b-th></b-th>
                </b-tr>
            </b-thead>
            <b-tbody v-if="wpDiscounts.length === 0">
                <b-tr>
                    <td colspan="5">
                        <i>No records available</i>
                    </td>
                </b-tr>
            </b-tbody>
            <draggable
                v-else
                v-model="wpDiscounts"
                tag="tbody"
                ghost-class="sort-row-ghost"
                drag-class="sort-row-drag"
                :animation="0"
                handle=".handle"
                @start="isRowDragging = true"
                @end="isRowDragging = false"
                @sort="itemSorted"
            >
                <tr v-for="discount in wpDiscounts" :key="discount.id">
                    <td class="handle">
                        <i class="cursor-move cus-black-white-swatch" />
                    </td>
                    <td>
                        {{
                            discount.item_type_category
                                ? discount.item_type_category.name
                                : ""
                        }}
                    </td>
                    <td>
                        {{ discount.discount }}
                    </td>
                    <td>
                        {{ _carbonDateDisplay(discount.create_at) }}
                    </td>
                    <td>
                        {{
                            discount.create_by
                                ? discount.create_by.full_name
                                : ""
                        }}
                    </td>
                    <td class="text-right small text-nowrap">
                        <span
                            v-if="isAbleEditOrDeleteItem"
                            title="Edit Item"
                            @click="editDiscount(discount)"
                            class="cursor-pointer"
                            >Edit</span
                        >
                        <span v-if="isAbleEditOrDeleteItem"> | </span>
                        <span
                            v-if="isAbleEditOrDeleteItem"
                            title="Delete Item"
                            @click="deleteDiscount(discount)"
                            class="cursor-pointer"
                        >
                            Delete
                        </span>
                    </td>
                </tr>
            </draggable>
        </b-table-simple>

        <ModalDeleteDiscount
            ref="modalDeleteDiscount"
            @reload="getNonPlanDiscounts"
        />
    </div>
</template>

<script>
/**
 * @name TemplateNonPlantDiscountList
 * @description List of Wellness Plan Non-Plan Discounts
 */

import TemplateService from "@/services/templates";
import TEMPLATES from "@/constants/templates";
import ModalDeleteDiscount from "@/components/setting-template/wellness-plan/modal-delete-discount";

export default {
    mixins: [],
    components: {
        Loader: () => import("@/components/elements/loader-list"),
        draggable: () => import("vuedraggable"),
        ModalDeleteDiscount
    },
    computed: {
        templateId() {
            return this.$store.state.settingsTemplate.templateId;
        },
        isAbleEditOrDeleteItem() {
            return (
                Number(
                    this.$store.state.settingsTemplate?.details
                        ?.wellness_plan_enrollees
                ) <= 0
            );
        },
        itemCategoryIds() {
            return this.wpDiscounts.map(item => item.category_id);
        }
    },
    watch: {},
    data() {
        return {
            isLoading: false,
            showPagination: false,
            wpDiscounts: [],
            isRowDragging: false,
            TEMPLATES
        };
    },
    mounted() {
        this.getNonPlanDiscounts();
    },
    destroyed() {},
    methods: {
        async getNonPlanDiscounts() {
            try {
                this.isLoading = true;

                const res = await TemplateService.getNonPlanDiscounts(
                    this.templateId
                );

                if (res.code === 200) {
                    this.wpDiscounts = res.resources.non_plans;
                } else {
                    throw new Error("Error: Unable to get non-plan discounts");
                }
            } catch (error) {
                console.log(error);
                this._message(
                    "Error: Unable to get non-plan discounts",
                    "danger"
                );
            } finally {
                this.$emit("reload-tab-count");
                this.isLoading = false;
            }
        },
        editDiscount(discount) {
            this.$emit("update-item", discount);
        },
        deleteDiscount(discount) {
            this.$refs.modalDeleteDiscount.open(this.templateId, discount);
        },
        async itemSorted() {
            const params = {
                id: this.templateId,
                data: this.wpDiscounts.map(item => item.id)
            };
            await TemplateService.updateWellnessPlanTemplateNonPlanDiscountsOrder(
                params
            )
                .then(res => {
                    if (res.code != 200) {
                        throw "Error: Cannot reorder non-plan discounts";
                    }

                    // reset order index
                    this.wpDiscounts = this.wpDiscounts.map((item, index) => ({
                        ...item,
                        index: index
                    }));
                })
                .catch(error => {
                    this._message(error, "danger");
                });
        }
    }
};
</script>
